/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MemberManagementListMemberRequest = {
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: MemberManagementListMemberRequest.direction | null;
    types?: string | null;
    statuses?: string | null;
    id?: number | null;
    nameOrCompany?: string | null;
    email?: string | null;
    eventNumber?: number | null;
};

export namespace MemberManagementListMemberRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

